import React, { memo, useEffect } from "react";
import { Table } from "antd";
import MainLayout from "../Layout/mainLayout";
import ListTopSearch from "./listTopSearch";
import "../Styles/tableStyles.css";

const TableComponent = ({
  pagination,
  dataSource,
  onChange,
  loading,
  setState,
  h3heading,
  buttonhead,
  buttonhead2,
  navigateTo2,
  columns,
  filterFunction,
  navigateTo,
  onDownload,
  onPressEnter,
  onDownloadUser,
  onDownloadProject,
  onDownloadBooking,
  onCalendarClick,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <MainLayout>
      <div
        className="row-span-8"
        style={{ gridColumn: "span 5", height: "auto" }}
      >
        <div className="table_component_all">
          <ListTopSearch
            buttonhead2={buttonhead2}
            navigateTo2={navigateTo2}
            h3heading={h3heading}
            onPressEnter={onPressEnter}
            setState={setState}
            filterFunction={filterFunction}
            onCalendarClick={() => onCalendarClick(false)}
            buttonhead={buttonhead}
            navigateTo={navigateTo}
            onDownload={onDownload}
            onDownloadUser={onDownloadUser}
            onDownloadProject={onDownloadProject}
            onDownloadBooking={onDownloadBooking}
          />
          <div className="custom_table">
            <div style={{ width: "90%" }}>
              <Table
                virtual
                scroll={{ x: 1700, y: 500 }}
                dataSource={dataSource}
                pagination={pagination}
                onChange={onChange}
                loading={loading}
                columns={columns}
                rowClassName={() => "text-center"}
              />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default memo(TableComponent);
